import { MAX_TILT, TILT_SMOOTHING, TILT_RETURN_SPEED } from '../config.js';

function clamp(v, lo, hi) {
  return Math.max(lo, Math.min(hi, v));
}

export class TiltController {
  constructor() {
    this.tiltX = 0;
    this.tiltZ = 0;
  }

  reset() {
    this.tiltX = 0;
    this.tiltZ = 0;
  }

  /**
   * @param {number} dt — seconds
   * @param {{ active: boolean, x: number, y: number }} input
   */
  update(dt, input) {
    const ix = input.active ? clamp(input.x, -1, 1) : 0;
    const iy = input.active ? clamp(input.y, -1, 1) : 0;

    const targetX = input.active ? iy * MAX_TILT : 0;
    const targetZ = input.active ? -ix * MAX_TILT : 0;

    const k = input.active ? TILT_SMOOTHING : TILT_RETURN_SPEED;
    const alpha = 1 - Math.exp(-k * dt);

    this.tiltX += (targetX - this.tiltX) * alpha;
    this.tiltZ += (targetZ - this.tiltZ) * alpha;
  }
}
